<template>
  <div class="container_box pb60" :style="documentData.length >0 ? {backgroundColor: '#F2F2F2'} : ''">
    <!--头部-->
    <vHeader :showNav="false"></vHeader>
    <!--主体内容-->
    <div class="problem-summary-box-content pt10" v-if="documentData.length >0">
      <!--左边的文章菜单栏-->
      <div class="left-box">
        <p class="title">{{ $t('key1000739') }}</p>
        <div class="problem-list" v-for="item in documentData">
          <p class="sub-title" @click="item.show = !item.show">
            <span class="text" :title="item.name">{{ item.name }}</span>
            <Icon :class="{rotate:item.show}" type="ios-arrow-down icon"/>
          </p>
          <ul class="problem-list" v-if="item.show">
            <li v-for="sub in item.children">
              <p class="sub-title" @click="sub.show = !sub.show">
                <span class="text second-menu" :title="sub.name">{{ sub.name }}</span>
                <Icon :class="{rotate:sub.show}" type="ios-arrow-down icon"/>
              </p>
              <ul v-if="sub.show && sub.helpDocsList">
                <li v-for="article in sub.helpDocsList" class="sub-title article" :class="{active: activeId === article.id}">
                    <span class="three-menu" :data-id="article.id" :title="article.title"
                      @click="setArticle(article)">{{ article.title }}</span>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
      <!--文章内容-->
      <div class="right-box">
        <div class="copy_box" @click="copyBtn">{{ $t('key1000003') }}</div>
        <div class="right-nav" v-if="breadMenu && breadMenu.length > 0">
          <span v-for="(item,index) in breadMenu">
            <span class="p-tit" :class="{'c-tit' : index === breadMenu.length -1}">{{ item }}</span>
            <span class="separate" v-if="index !== breadMenu.length -1">/</span>
          </span>
        </div>
        <p class="content-title">{{ contentTitle }}</p>
        <div class="online_content_box" v-if="contentType === 0">
          <iframe :src="pdfUrl" frameborder="0" :style="iframeStyle"></iframe>
        </div>
        <div class="right-content" v-if="contentType === 1" v-viewer="viewerOptions" ref="scrollContainer" v-html="content"></div>
      </div>
      <!--右侧的锚点导航-->
      <anchorNavigation ref="anchorNav" setTop="145px" :headerHeight="65"></anchorNavigation>
    </div>
    <div v-else class="no_classify">
      <img :src="noContent" width="200" height="auto" alt="no content">
      <div class="txt">{{ $t('key1000104') }}</div>
    </div>
    <!--返回顶部-->
    <AppBackTop :bottom="60"></AppBackTop>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import vHeader from "@/components/layout/header.vue";
import anchorNavigation from "@/components/common/anchorNavigation.vue";
import {commonCopyContent, fixCategoryLang, setLinkPath} from "@/utils/common";
import {HELP_CENTER_PLATFORM} from "@/utils/enum";
import AppBackTop from "@/components/common/AppBackTop.vue";

export default {
  name: 'helpCenter',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      documentData: [],
      activeId: null,
      breadMenu: [],
      iframeStyle: {
        width: '100%',
        minHeight: 'calc(100vh - 57px)',
        border: 'none',
      },
      contentType: 1,
      pdfUrl: '',
      content: '',
      contentTitle: '',
      helpDoscList: [],
      system: null,
      activeDocsId: null,
      noContent: require('@/assets/images/noContent.gif'),
    };
  },
  created() {
    const _system = localStorage.getItem('system');
    let docsId = this.$route.query.docsId;
    if (_system) {
      this.system = _system;
    }
    this.activeDocsId = docsId;

    this.getDetils().then(() => {
      if (docsId) {
        this.$nextTick(() => {
          this.activeId = docsId;
          this.helpDoscList.forEach(i => {
            if (i.docsId === docsId) {
              this.setArticle(i);
              this.tabIndex = 0;
            }
          });
        });
      } else {
        this.seletDefaultArticle(this.documentData);
      }

    });
  },
  methods: {
    async getSector(_system) {
      const {data} = await this.axios.get(api.get_helpCenterSector_listNoPermission + '?platformId=' + _system);
      const {code, datas} = data;
      if (code === 0) {
        return datas;
      }
    },
    // 改数据格式
    newToOld(data) {
      let v = this;
      return data.map(item => {
        item.pId = item.parentCategoryId;
        item.id = item.categoryId;
        item.helpDocsList = (item.docsList || []).map(docs => {
          docs.helpDocInternationalList = fixCategoryLang(docs.docsInternationalList, 'title') || [];
          docs.id = docs.docsId;
          let obj = docs.helpDocInternationalList.find(dItem => dItem.language === v.languagesVal);
          docs.title = obj.title;
          docs.content = obj.content;
          docs.contentType = obj.contentType;
          docs.showStatus = true;
          docs.showStatus = true;
          docs.isDeleted = false;
          return docs;
        });
        item.categoryInternational = fixCategoryLang(item.internationalCategoryList, 'name') || [];
        delete item.parentCategoryId;
        delete item.categoryId;
        delete item.docsList;
        delete item.internationalCategoryList;
        return item;
      });
    },
    // 获取所有目录
    async getDetils() {
      let v = this;

      function recursion(originData, topId) {
        let obj = {};
        let p = 0;
        v.helpDoscList = [];
        originData.forEach(i => {
          let name = i.name;
          let categoryInternational = i.categoryInternational || [];
          if (categoryInternational.length > 0) {
            categoryInternational.map((item) => {
              if (item.language === v.languagesVal) {
                name = item.name;
              }
            });
          } else {
            name = i.name;
          }
          i.children = [];
          i.show = true;
          i.fullName = [name];
          obj[i.id] = i;
          if (obj[i.pId]) {
            i.fullName.push(...obj[i.pId].fullName);
            if (i.helpDocsList) {
              i.helpDocsList = i.helpDocsList.filter(i => (i.showStatus || i.docsId === v.activeDocsId) && !i.isDeleted);
              i.helpDocsList.forEach(d => d.fullName = i.fullName);
              v.helpDoscList.push(...i.helpDocsList);
              i.helpDocsList.map((ele) => {
                let helpDocInternationalList = ele.helpDocInternationalList || [];
                if (helpDocInternationalList.length > 0) {
                  helpDocInternationalList.map((talg) => {
                    if (talg.language === v.languagesVal) {
                      ele.title = talg.title;
                      ele.content = talg.content;
                    }
                  });
                }
              });
            }
            if (categoryInternational.length > 0) {
              categoryInternational.map((item) => {
                if (item.language === v.languagesVal) {
                  i.name = item.name;
                }
              });
            }
            obj[i.pId].children.push(i);
          }
          if (i.pId === topId) {
            p = i.id;
          }
        });
        return obj[p].children;
      }

      let _system = HELP_CENTER_PLATFORM[v.system];
      const topData = await this.getSector(_system);


      let topId = topData.find(i => i.platformId === _system).parentId;
      if (!topId) return;
      return new Promise(resolve => {
        v.axios.get(api.get_helpCenterCategory_listByPlatformId, {
          params: {
            platformId: _system,
          }
        }).then(response => {
          if (response.data.code === 0) {
            let newData = response.data.datas || [];
            newData = newData.filter(i => i.showStatus === 1);
            let _data = v.newToOld(newData);
            v.documentData = recursion(_data, topId);
            resolve();
          }
        });
      });
    },
    // 默认选中第一篇文章
    seletDefaultArticle(data) {
      if (data && data.length > 0) {
        function treeToList(tree, result = []) {
          tree.forEach(node => {
            result.push(node);
            node.children && treeToList(node.children, result);
            node.helpDocsList && treeToList(node.helpDocsList, result);
          });
          return result;
        }

        let newData = this.uniqueFunc(treeToList(data), 'id');
        let list = newData.filter((item) => {
          if (!item.helpDocsList && !item.children) {
            return item;
          }
        });
        if (list && list.length > 0) {
          this.setArticle(list[0], true);
        }
      }
    },
    // 记录浏览量
    recordViews(id) {
      let v = this;
      v.axios.get(api.get_helpCenterDocs_increaseViewsQuantity + `?docsId=${id}`).then(response => {
        if (response.data.code === 0) {
        }
      });
    },
    // 选择文章
    async setArticle(article, value) {
      let v = this;
      if (value) {
        v.tabIndex = 0;
      }
      v.activeId = article.id;
      v.content = article.content;
      if (article.contentType === 0) {
        try {
          let jsData = JSON.parse(article.content);
          v.pdfUrl = setLinkPath(jsData.url);
        } catch (e) {
          v.pdfUrl = setLinkPath(article.content);
        }

      }
      v.contentType = article.contentType;
      v.contentTitle = article.title;
      v.breadMenu = article.fullName.slice(0, -1).reverse();
      v.recordViews(article.id);
      v.scrollTopFun();
      setTimeout(() => {
        v.$nextTick(() => {
          const content = v.$el.querySelector('.right-content');
          let dom = v.$refs['scrollContainer'];
          v.$refs['anchorNav'].getAnchorsFromContent(dom, content);
        }, 1000);
      });
    },
    // 复制
    copyBtn() {
      let href = window.location.href;
      let content = `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000000')}${this.contentTitle}\n` + `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000001')}${href}`;
      if (content) {
        commonCopyContent(content, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000002'));
      }
    }
  },
  watch: {},
  components: {
    anchorNavigation,
    vHeader,
    AppBackTop
  }
};
</script>

<style lang="less">
.container_box {
  min-height: 100vh;

  .problem-summary-box-content {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    .left-box {
      width: 230px;
      background-color: #ffffff;

      .title {
        padding: 0 24px;
        height: 46px;
        line-height: 46px;
        font-family: 'Arial Negreta', 'Arial Normal', 'Arial', sans-serif;
        font-weight: 700;
        font-style: normal;
        font-size: 14px;
        text-align: left;
      }

      .problem-list {
        line-height: 46px;
        color: #333333;
        font-size: 14px;

        .sub-title {
          height: 46px;
          padding: 0 24px;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .text {
            text-align: left;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .icon {
            text-align: right;
            transition: 0.2s ease-in transform;
          }

          .rotate {
            transform: rotate(180deg);
          }
        }

        .active {
          color: #2D8CF0;
          background-color: #FFF5F1;
        }

        .sub-title:hover {
          color: #2D8CF0;
          background-color: #FFF5F1;
        }

        .item-box {
          .item {
            padding-left: 48px;
            height: 46px;
            cursor: pointer;
          }

          .item:hover, .active {
            color: #2D8CF0;
            background-color: #FFF5F1;
          }
        }
      }
    }

    .right-box {
      width: 960px;
      background-color: #ffffff;
      position: relative;

      .copy_box {
        position: absolute;
        top: 75px;
        right: 20px;
        z-index: 10;
        cursor: pointer;
      }

      .right-nav {
        height: 48px;
        line-height: 48px;
        background-color: #F2F2F2;

        .separate {
          padding: 0 5px;
        }

        .p-tit {
          color: #00000072;
        }

        .c-tit {
          color: #000000;
        }
      }

      .right-content {
        padding: 24px;
        overflow: hidden;
      }

      .content-title {
        font-size: 16px;
        color: #000;
        font-weight: bold;
        padding: 24px 24px 0 24px;
      }
    }
  }

  .no_classify {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 90vh;

    .txt {
      font-size: 15px;
      color: #666;
      margin-top: 15px;
    }
  }
}

.right-content img {
  max-width: 100%;
}

.right-content p span {
  word-wrap: break-word;
  word-break: break-all;
  text-wrap: initial !important;
}

.second-menu {
  padding-left: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.three-menu {
  padding-left: 28px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.article {
  cursor: pointer;
}
</style>
